export const mainHeaderId = "main-header";
export const mainContainerId = "main-container";
export const blockRegistrationOnBoarding = "blockRegistrationOnBoarding";

export const searchNavigationId = "searchNavigation";

export const allStoresPanelId = "allStoresPanelId";
export const searchHistoryKey = "search_list";
export const contactTypeParamName = "contactType";

export const externalAuthenticationCookie = "externalAuthenticationStatus";

export const showOnBoarding = "showOnBoarding";
export const showRegistration = "showRegistration";

export const openTransactionsModal = "openTransactionsModal";
export const scrollToCbBrandsList = "scrollToCbBrands";
export const scrollToCbFAQ = "scrollToCbFAQ";
export const cashbackTooltipMessage = "message";
export const cashbackTransactionTab = "trxTab";
export const cashbackTransactionId = "trxId";

export const missingTransactionUrlParam = "missingTransaction";

export const mgmServicesCodeKey = "redeemCode";
export const pluginOnboarding = "pluginOnboarding";
export const pluginInstallBtnId = "pluginInstallBtnId";

export const mobileAppInstallKey = "mobileAppInstall";

export const openProcessId = "openProcessId";

export const whatIsCashbackPanelId = "whatIsCashbackPanel";
export const allStoresCategoriesPanelId = "allStoresCategories";

export const flyerPageQueryParam = "flyerPage";
export const pluginLpFaqId = "pluginLpFaq";

export const usedPopularPhrasesCounterKey = "usedPopularPhrasesCounter";
export const searchQueryParam = "search";

export const forceSearchFocusHash = "#search";
export const queryAuthenticationKey = "authentication";

export const FaqLandingPage = "/cashback/pytania-i-odpowiedzi";
